import { render, staticRenderFns } from "./CatalogViewMoreButton.vue?vue&type=template&id=47e09d50"
import script from "./CatalogViewMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogViewMoreButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports